import {Component, Inject, OnChanges, OnInit, ViewChild} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
    MatSnackBar,
    MatChipInputEvent,
    MatAccordion,
    MatCheckboxChange,
    MatTabGroup
} from '@angular/material';
import {FormGroup, FormBuilder} from '@angular/forms';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ConfService} from '../conf.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Location} from '@angular/common';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {HeadersComponent} from '../devex/headers/headers.component';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {EmailtemplateListenerService} from '../emailtemplate-listener.service';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {MatStepper} from '@angular/material/stepper';
import {AccountInfoService} from '../user/account-info.service';

declare let $;

@Component({
    selector: 'app-executeemailtemplate',
    templateUrl: './executeemailtemplate.component.html',
    styleUrls: ['./executeemailtemplate.component.scss']
})
export class ExecuteemailtemplateComponent implements OnInit, OnChanges {

    public selectedIndex = 0;
    isLinear = true;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;
    fourthFormGroup: FormGroup;
    fifthFormGroup: FormGroup;

    @ViewChild('stepper') stepper: MatStepper;

    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');

    subject = '';
    recipientModes = [
        {
            mode: 'manual',
            displayName: 'Enter Manually'
        },
        {
            mode: 'csv',
            displayName: 'Upload CSV'
        },
        {
            mode: 'subscribers',
            displayName: 'Select from Subscriber List'
        },
        {
            mode: 'copyPaste',
            displayName: 'Comma Separated TO List'
        },
        {
            mode: 'API',
            displayName: 'Execute an API'
        }
        // {
        //     mode: 'integrations',
        //     displayName: 'Integrate from 3rd party services'
        // }
    ];

    selectedAPICallMode = 'Configure an API';
    APICallModes = [
        {
            mode: 'Configure an API'
        },
        {
            mode: 'Use my API'
        }
    ];
    modeOfManualEntry: any;

    selectedTab: any;
    selectedTemplate: any;
    templateBody: any;
    recipientMode: string;
    templateName: string;
    templates = [];
    columns = [];
    items = [];
    emailIndexInCSV: number;
    payloadToSend = {
        serverConfig: {},
        from: {
            name: '',
            email: ''
        },
        to: {
            type: ''
        },
        subject: '',
        body: {
            type: 'Simple Text',
            value: []
        },
        partner: localStorage.getItem('partner'),
        account: localStorage.getItem('account')
    };
    parameters = [];
    showParameters = false;
    templateParameters = [];
    recipientSpecificParameters = [];

    recipientSpecificParametersPayload = [];
    dummyPayload = {};
    count = 0;

    httpOperation: any;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
        // {'name': 'COPY'},
        // {'name': 'HEAD'},
        // {'name': 'OPTIONS'},
        // {'name': 'LINK'},
        // {'name': 'UNLINK'},
        // {'name': 'LOCK'},
        // {'name': 'UNLOCK'},
        // {'name': 'PROPFIND'},
        // {'name': 'PURGE'},
        // {'name': 'VIEW'}
    ];
    httpUrl: string;
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    formData = [];
    requestBodySelected = 'none';
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild('tabref4') tabref4: MatTabGroup;

    options1 = new JsonEditorOptions();

    showPathParamters: boolean;
    devExURL = '';
    isCountOfResAtt: boolean;
    pathParameterSegregator: any;
    find: any;
    pathParameterStopper: any;
    pathParameterValue: any;

    requestBody: any;
    rawRequestBody: any;

    authAttributes = {};
    authModel = {
        'authAttributes': this.authAttributes
    };

    formDataTrue = true;
    formURLEncodedTrue = true;

    responseData: any;
    errorMessage: any;
    responseError: any;

    executorName: string;
    executorVersion: string;
    executor_url: string;
    executor_name: string;
    executor_version: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    apiByDefinition: any;
    categories: any;
    entities = [];

    APIExecutorCategory = [];
    businessLogicAPIExecutorCategory = [];
    thirdPartyAPIExecutorCategory = [];
    SQLQueryAPIExecutorCategory = [];
    WorkflowAPIExecutorCategory = [];
    TestSuiteAPIExecutorCategory = [];
    DMNAPIExecutorCategory = [];
    PLSQLAPIExecutorCategory = [];

    DataAccessAPIByCategory = [];
    businessLogicAPIByCategory = [];
    thirdPartyAPIByCategory = [];
    SQLQueryAPIByCategory = [];
    WorkflowAPIByCategory = [];
    TestSuiteAPIByCategory = [];
    DMNAPIByCategory = [];
    PLSQLAPIByCategory = [];


    basicPermission: boolean;

    DisplayApiByCategory = true;

    APITypes = [
        {
            type: 'Data Access API',
            category: this.APIExecutorCategory
        },
        {
            type: 'Business Logic API',
            category: this.businessLogicAPIExecutorCategory
        },
        {
            type: 'Third Party API',
            category: this.thirdPartyAPIExecutorCategory
        },
        {
            type: 'SQL Query API',
            category: this.SQLQueryAPIExecutorCategory
        },
        {
            type: 'Workflow API',
            category: this.WorkflowAPIExecutorCategory
        }
    ];

    serverConfigurations = [
        // {
        //     server_name: 'default'
        // }
    ];

    from = [
        // {
        //     email: 'campaign@apiplatform.io'
        // }
    ];

    delimiters = [
        {
            delimiter: ':'
        },
        {
            delimiter: ','
        }
    ];
    selectedDelimiter = ',';

    commaSeparatedList: any;

    DAASExecutors: any;
    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    workFlowExecutors: any;

    apisByCategory: any;
    dataAccess = [];
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];
    testSuite = [];
    PLSQL = [];

    DisplayCustomOperation = true;
    executor: any;

    headers = [];
    queryParams = [];
    prerequisites: any;
    showAPIBrowser = true;

    itemList = [];
    filterData: any[];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    searchText: string;
    subscriberColumns = [];
    subscribersColumnsLength: number;
    subscribersData: any;
    selectAll = false;
    subscribersChecked = [];
    settingsData: any;

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(public platform: LeftpanelComponent,
                private route: ActivatedRoute,
                private _service: ConnecttocrudService,
                public dialog: MatDialog,
                private confPost: ConfService,
                private _formBuilder: FormBuilder,
                private location: Location,
                public accountInfoService: AccountInfoService,
                public router: Router,
                public emailTemplatesListenerInstance: EmailtemplateListenerService) {
    }

    async ngOnInit() {


        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.route.queryParams
            .subscribe(params => {
                if (params) {
                    if (params.template && params.template !== '') {
                        this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&name=' + params.template).subscribe(response => {
                            this.tabref4.selectedIndex = 1;
                            this.templateName = params.template;
                        });
                    }
                }
            });

        this._service.getItems('v1', 'campaign', 'campaign', 'emailTemplate', false).subscribe(response => {
            // this.templates = response;
            const iterator = response[Symbol.iterator]();
            while (true) {
                const itr = iterator.next();
                if (itr.done) {
                    break;
                }
                if (itr['value']['partner'] === localStorage.getItem('partner') && itr['value']['account'] === localStorage.getItem('account')) {
                    this.templates.push(itr.value);
                }

            }
            for (const template of this.templates) {
                if (template['name'] === this.templateName) {
                    this.payloadToSend.body.type = 'template';
                    this.payloadToSend.body.value = template['body'];
                    this.selectedTemplate = template;
                }
            }
        });

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
            this.settingsData = this.platform.settingsData;
        } else {
            await this.platform.getSettingsData(this.partner, this.account, false);
            if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
                this.settingsData = this.platform.settingsData;
            } else {
                this.platform.openSnackBar('Error while fetching the settings data. Please try again sometime.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.router.navigateByUrl('/controlplane');
            }
        }

        if (this.settingsData && this.settingsData['body'] && this.settingsData['body'][0]) {
            for (const env of this.settingsData['body'][0]['environments']) {
                if (env['name'] === this.partner) {
                    env['services'].filter(service => {
                        if (service.name === 'Email Configurations') {
                            this.serverConfigurations = service['configurations'];
                        }
                    });
                }
            }
            this.serverConfigurations.push({
                'server_name': 'default',
                'fromEmailAddresses': ['campaign@apiplatform.io']
            });
            // this.payloadToSend.serverConfig['server_name'] = 'default';
            // this.from = ['admin@apiplatform.io'];
        }

        this.confPost.getEntity(this.partner, this.account, 'subscriber', 'v1').subscribe(response => {
            if (response) {
                for (const attribute of response['attributes']) {
                    this.subscriberColumns.push(attribute['attributeName']);
                }
                this.subscribersColumnsLength = this.subscriberColumns.length;
                this.itemList = [];
                for (let t = 0; t < this.subscriberColumns.length; t++) {
                    const tempObj = {};
                    tempObj['id'] = t;
                    tempObj['itemName'] = this.subscriberColumns[t];
                    this.itemList.push(tempObj);
                }
            }
        });

        this._service.getItems('v1', this.partner, this.account, 'subscriber', false).subscribe(response => {
            this.subscribersData = response;
        });

        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        }

        bindEvent(window, 'message', function (e) {
            this.results = e.data;
            localStorage.setItem('htmlContent', e.data);
            this.body = e.data;
        });
        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: [],
            secondCtrl: []
        });
        this.secondFormGroup = this._formBuilder.group({});
        this.thirdFormGroup = this._formBuilder.group({
            thirdCtrl: [],
            thirdCtrl1: []
        });

        if (localStorage.getItem('partner')) {
            // getBusinessTemplatesForPartner
            if (localStorage.getItem('account')) {
                this.getCategoriesEntitiesForPartner();
                this.getBusinessLogicApiExecutorsByPartnerAccountType();
                this.getThirdPartyApiExecutorsByPartnerAccountType();
                this.getSqlQueryApiExecutorsByPartnerAccountType();
                this.getWorkFlowApiExecutorsByPartnerAccountType();
            }
        }
        this.basicPermission = true;
        this.platform.setGuideTourSteps(this.getEmailTemplateBuilderTourSteps());

        if (this.platform.partnerExecutors === null || this.platform.partnerExecutors === undefined || this.platform.partnerExecutors.length === 0) {
            await this.platform.getExecutorsForPartnerAccount();
        }

        if (this.platform.partnerExecutors) {
            let apiExecutors: any;
            apiExecutors = this.platform.partnerExecutors;
            const tempCategoryarray = [];
            const tempCategoryarray1 = [];
            const tempCategoryarray2 = [];
            const tempCategoryarray3 = [];
            const tempCategoryarray4 = [];
            const tempCategoryarray5 = [];
            const tempCategoryarray6 = [];

            for (let i = 0; i < apiExecutors.length; i++) {
                for (let j = 0; j < apiExecutors[i]['executors'].length; j++) {
                    switch (apiExecutors[i]['executors'][j]['executor_type']) {
                        case 'API':
                            const apiName = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray.includes(apiName) === false) {
                                tempCategoryarray.push(apiName);
                                this.APIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName
                                    });
                                this.DataAccessAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'WORKFLOW':
                            const apiName1 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray1.includes(apiName1) === false) {
                                tempCategoryarray1.push(apiName1);
                                this.WorkflowAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName1
                                    });
                                this.WorkflowAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'BUSINESSLOGIC':
                            const apiName2 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray2.includes(apiName2) === false) {
                                tempCategoryarray2.push(apiName2);
                                this.businessLogicAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName2
                                    });
                                this.businessLogicAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'SQLQUERY':
                            const apiName3 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.SQLQueryAPIExecutorCategory.includes(apiName3) === false) {
                                tempCategoryarray3.push(apiName3);
                                this.SQLQueryAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName3
                                    });
                                this.SQLQueryAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'TESTSUITE':
                            const apiName4 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.TestSuiteAPIExecutorCategory.includes(apiName4) === false) {
                                tempCategoryarray4.push(apiName4);
                                this.TestSuiteAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName4
                                    });
                                this.TestSuiteAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'DMN':
                            const apiName5 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.DMNAPIExecutorCategory.includes(apiName5) === false) {
                                tempCategoryarray5.push(apiName5);
                                this.DMNAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName5
                                    });
                                this.DMNAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'PLSQL':
                            const apiName6 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.PLSQLAPIExecutorCategory.includes(apiName6) === false) {
                                tempCategoryarray6.push(apiName6);
                                this.PLSQLAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName6
                                    });
                                this.PLSQLAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;

                    }
                }
            }
        }

        // this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
        //     .toPromise().then(data => {
        //
        //
        //     // for (let i = 0; i < this.APIExecutorCategory.length; i++) {
        //     //     for (let j = 0; j < apiExecutors.length; j++) {
        //     //         if (this.APIExecutorCategory[i]['category'] === apiExecutors[i]['executors'][j]['executor_category']) {
        //     //             this.DataAccessAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']].push(apiExecutors[i]['executors'][j]);
        //     //         }
        //     //     }
        //     // }
        // });

        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            for (let i = 0; i < this.categories.length; i++) {
                                for (let j = 0; j < this.categories[i].entities.length; j++) {
                                    const tempJSON = {};
                                    tempJSON['entity'] = this.getEntity(this.categories[i].entities[j]);
                                    tempJSON['version'] = this.getVersion(this.categories[i].entities[j]);
                                    this.entities.push(tempJSON);
                                }
                            }
                        }
                    });
                }
            });

        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];
    }

    // selectionChanged(event: any): void {
    //     this.selectedIndex
    // }

    getEmailTemplateBuilderTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_INTRO_TITLE'),
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_INTRO_CONTENT')
        });

        steps.push({
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_TAB_TITLE'),
            selector: '.tour-execute-email-template-steppers > div > mat-step-header:nth-child(1)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_TAB_CONTENT'),
            orientation: Orientation.Right,
            action: (() => {
                this.selectedIndex = 0;
            })
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_SERVER_TITLE'),
            selector: '.tour-execute-email-template-server',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_SERVER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_MAIL_TITLE'),
            selector: '.tour-execute-email-template-from-address',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_MAIL_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_NAME_TITLE'),
            selector: '.tour-execute-email-template-from-name',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_FROM_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_TAB_TITLE'),
            selector: '.tour-execute-email-template-steppers > div > mat-step-header:nth-child(3)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedIndex = 1;
            })
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_MANUALLY_TITLE'),
            selector: '.tour-execute-email-template-to-address-inputs > mat-radio-group > mat-radio-button:nth-child(1)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_MANUALLY_TITLE'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_CSV_TITLE'),
            selector: '.tour-execute-email-template-to-address-inputs > mat-radio-group > mat-radio-button:nth-child(2)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_CSV_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_SUBSCRIBER_LIST_TITLE'),
            selector: '.tour-execute-email-template-to-address-inputs > mat-radio-group > mat-radio-button:nth-child(3)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_SUBSCRIBER_LIST_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_COMMA_SEPARATED_TITLE'),
            selector: '.tour-execute-email-template-to-address-inputs > mat-radio-group > mat-radio-button:nth-child(4)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_COMMA_SEPARATED_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_API_TITLE'),
            selector: '.tour-execute-email-template-to-address-inputs > mat-radio-group > mat-radio-button:nth-child(5)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_TO_API_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SUBJECT_TAB_TITLE'),
            selector: '.tour-execute-email-template-steppers > div > mat-step-header:nth-child(5)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SUBJECT_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedIndex = 2;
            })
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SUBJECT_TITLE'),
            selector: '.tour-execute-email-template-subject',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SUBJECT_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_BODY_TAB_TITLE'),
            selector: '.tour-execute-email-template-steppers > div > mat-step-header:nth-child(7)',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_BODY_TAB_CONTENT'),
            orientation: Orientation.Left,
            action: (() => {
                this.selectedIndex = 3;
            })
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_SIMPLE_TEXT_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_SIMPLE_TEXT_TAB_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_HTML_CONTENT_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_HTML_CONTENT_TAB_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EMAIL_DESIGNER_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            content: this.platform.getProperty('GT_EMAIL_TEMPLATE_BUILDER_EMAIL_DESIGNER_TAB_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_EXECUTE_TEMPLATE_SELECT_TEMPLATE_TAB_TITLE'),
            selector: '.tour-template-builder-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
            content: this.platform.getProperty('GT_EXECUTE_TEMPLATE_SELECT_TEMPLATE_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            closeAction: (() => {
                this.selectedIndex = 0;
            })
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_EXECUTE_TITLE'),
            selector: '.tour-execute-email-template-execute',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_EXECUTE_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SCHEDULE_TITLE'),
            selector: '.tour-execute-email-template-schedule',
            content: this.platform.getProperty('GT_EXECUTE_EMAIL_TEMPLATE_SCHEDULE_CONTENT'),
            orientation: Orientation.Left
        });


        return steps;

    }

    showOptions(event: MatCheckboxChange, index): void {
        if (event.checked) {
            this.subscribersChecked.push(this.subscribersData[index]);
        } else {
            for (let i = 0; i < this.subscribersChecked.length; i++) {
                if (this.subscribersChecked[i]['email'] === this.subscribersData[index]['email']) {
                    this.subscribersChecked.splice(i, 1);
                }
            }
        }
    }

    getCategoriesEntitiesForPartner() {
        // if (this.categories.length === 0) {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            if (this.categories && this.categories.length > 0) {
                                this.DisplayApiByCategory = true;
                                this.DisplayCustomOperation = true;
                            } else {
                                this.DisplayApiByCategory = false;
                                this.DisplayCustomOperation = false;
                            }
                        }
                    });
                }
            });
        // }
    }

    // getDAASAPIExecutorsByPartnerAccountType() {
    //     this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'API').subscribe(data => {
    //         this.DAASExecutors = data;
    //         localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
    //     });
    // }

    setServerConfiguration(event) {
        this.from = event['value']['fromEmailAddresses'];
    }

    async getBusinessLogicApiExecutorsByPartnerAccountType() {
        if (this.platform.businessLogicExecutors !== null && this.platform.businessLogicExecutors !== undefined && this.platform.businessLogicExecutors !== '') {
            this.businessLogicExecutors = this.platform.businessLogicExecutors;
        } else {
            await this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.businessLogicExecutors = this.platform.businessLogicExecutors;
            });
        }

    }

    getThirdPartyApiExecutorsByPartnerAccountType() {
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     // localStorage.setItem('dataAccessAPI' , JSON.stringify(this.apiExecutors));
        // });
        this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
            // this.thirdPartyApiExecutors = data;
            this.apisByCategory = data;
            for (let i = 0; i < this.apisByCategory.length; i++) {
                const tempDataAccess = [];
                const tempbusinessLogic = [];
                const tempsql = [];
                const tempworkflow = [];
                const tempdecision = [];
                for (let j = 0; j < this.apisByCategory[i]['executors'].length; j++) {
                    let temp: string;
                    temp = '';
                    if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'API') {
                        tempDataAccess.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'BUSINESSLOGIC') {
                        tempbusinessLogic.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'SQLQUERY') {
                        tempsql.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'WORKFLOW') {
                        tempworkflow.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'DECISION') {
                        tempdecision.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    }
                }
                if (tempDataAccess.length > 0) {
                    this.dataAccess.push({'executors': tempDataAccess, 'category': this.apisByCategory[i]['category']});
                }
                if (tempbusinessLogic.length > 0) {
                    this.businessLogic.push({
                        'executors': tempbusinessLogic,
                        'category': this.apisByCategory[i]['category']
                    });
                }
                if (tempsql.length > 0) {
                    this.sql.push({'executors': tempsql, 'category': this.apisByCategory[i]['category']});
                }
                if (tempworkflow.length > 0) {
                    this.workflow.push({'executors': tempworkflow, 'category': this.apisByCategory[i]['category']});
                }
                if (tempdecision.length > 0) {
                    this.decision.push({'executors': tempdecision, 'category': this.apisByCategory[i]['category']});
                }
            }
        });
    }

    getSqlQueryApiExecutorsByPartnerAccountType() {
        if (this.platform.sqlQueryExecutors !== null && this.platform.sqlQueryExecutors !== undefined && this.platform.sqlQueryExecutors !== '') {
            this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
            });
        }
    }

    getWorkFlowApiExecutorsByPartnerAccountType() {
        if (this.platform.workFlowExecutors !== null && this.platform.workFlowExecutors !== undefined && this.platform.workFlowExecutors !== '') {
            this.workFlowExecutors = this.platform.workFlowExecutors;
        } else {
            this.platform.getExecutorsForPartnerAccount().then(resp => {
                this.workFlowExecutors = this.platform.workFlowExecutors;
            });
        }
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    async ngOnChanges() {

    }

    saveDescription(value) {
        this.payloadToSend.body.value = value;
    }

    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }

    goBack() {
        this.location.back();
    }

    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }

    addRecipientParameters() {
        const dummyPayload = {};
        for (const parameter of this.parameters) {
            dummyPayload[parameter] = '';
        }
        this.recipientSpecificParametersPayload.push(dummyPayload);
    }

    removeRecipientParameters(index) {
        this.recipientSpecificParametersPayload.splice(index, 1);
    }

    csvtoJson(csv: any[]) {
        const parameters = [];
        const to = [];
        csv.splice(0, 1);
        csv.forEach(element => {
            const parameterPayload = {};
            const elements = element.split(',');
            // to.push(elements[this.emailIndexInCSV].replace('\n', ''));
            const tempPayload = [];
            for (let i = 0; i < elements.length; i++) {
                parameterPayload[this.columns[i]] = elements[i].replace('\n', '');
            }
            // const tempParameterPayload = {};
            parameters.push(parameterPayload);
        });
        this.recipientSpecificParametersPayload = parameters;
    }

    getHeaderArray(csvRecordsArr: any) {
        const headers = (<string>csvRecordsArr[0]).split(',');
        for (let j = 0; j < headers.length; j++) {
            this.columns.push(headers[j]);
            if (headers[j] === 'email') {
                this.emailIndexInCSV = j;
            }
        }
    }

    changeListener(files: FileList) {
        this.recipientSpecificParametersPayload = [];
        this.columns = [];
        if (files && files.length > 0) {
            const file: File = files.item(0);
            const reader: FileReader = new FileReader();
            reader.readAsText(file);
            reader.onload = (e) => {
                const csv: any = reader.result;
                const csv1 = csv.split(/\r\n|\n/);
                this.getHeaderArray(csv1);
                this.csvtoJson(csv.split('\r'));
            };
        }
    }

    selectTemplate() {
        for (const template of this.templates) {
            if (template['name'] === this.templateName) {
                this.payloadToSend.body.type = 'template';
                this.payloadToSend.body.value = template['body'];
                this.selectedTemplate = template;
                // if (this.selectedTemplate.inputType === 'simpleText') {
                //     this.selectedTab = 0;
                // } else if (this.selectedTemplate.inputType === 'htmlContent') {
                //     this.selectedTab = 1;
                // } else if (this.selectedTemplate.inputType === 'emailDesigner') {
                //     this.selectedTab = 2;
                // }
            }
        }
    }

    confirmCommaSeparatedList() {
        const pastedContent = this.commaSeparatedList.split(this.selectedDelimiter);
        this.recipientSpecificParametersPayload = [];

        let name = [];
        for (let i = 0; i < pastedContent.length; i++) {
            if (pastedContent[i].includes('<')) {
                const init = pastedContent[i].indexOf('<');
                const fin = pastedContent[i].indexOf('>');
                name = pastedContent[i].split('<');
                name[0] = name[0].substring(0, name[0].length - 1);
                if ((!(this.recipientSpecificParametersPayload.some(e => e.key === pastedContent[i].substr(init + 1, fin - init - 1))) && pastedContent[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    if (name[0].length > 0) {
                        this.recipientSpecificParametersPayload.push({
                            'email': pastedContent[i].substr(init + 1, fin - init - 1),
                            'name': name[0]
                        });
                    } else {
                        this.recipientSpecificParametersPayload.push({'email': pastedContent[i].substr(init + 1, fin - init - 1)});
                    }
                }
            } else {
                this.recipientSpecificParametersPayload.push({'email': pastedContent[i]});
            }
        }
    }

    onTabChange(event) {
        if (event.tab.textLabel === 'Simple Text') {
            this.payloadToSend.body.type = 'simpleText';
        } else if (event.tab.textLabel === 'HTML Content') {
            this.payloadToSend.body.type = 'htmlText';
        } else if (event.tab.textLabel === 'Email Designer') {
            this.payloadToSend.body.type = 'emailDesigner';
        } else if (event.tab.textLabel === 'Select Template') {
            this.payloadToSend.body.type = 'template';
        }

    }

    recipientModeChange() {
        this.parameterData = [];
        this.pathParameter = [];
        this.headersData = [];
        this.formData = [];
        this.requestBodySelected = 'none';
        this.httpOperation = 'GET';
        this.httpUrl = '';
        this.parameters = [];
        this.recipientSpecificParametersPayload = [];
        if (this.recipientMode === 'manual') {
            // this.parameterDataCheck(this.templateBody);
            this.addParameters();
            this.payloadToSend.to.type = 'manual';
        } else if (this.recipientMode === 'manual') {
            this.payloadToSend.to.type = 'csv';
        } else if (this.recipientMode === 'manual') {
            this.payloadToSend.to.type = 'csv';
        } else if (this.recipientMode === 'copyPaste') {
            this.payloadToSend.to.type = 'copyPaste';
        } else if (this.recipientMode === 'API') {
            this.payloadToSend.to.type = 'API';
        } else if (this.recipientMode === 'subscribers') {
            this.payloadToSend.to.type = 'subscribers';
        }
    }

    addParameters() {
        this.parameters = ['email'];
        const parameters = ['email'];
        this.recipientSpecificParametersPayload = [];
        const dialogRef = this.dialog.open(DifferentiateParametersComponent, {
            disableClose: true,
            width: '40%',
            data: {data: parameters}
        });

        dialogRef.afterClosed().subscribe(result => {
            const dummyPayload = {};
            if (result !== 'cancel') {
                this.parameters = result;
                for (const parameter of this.parameters) {
                    dummyPayload[parameter] = '';
                }
                this.recipientSpecificParametersPayload.push(dummyPayload);
            } else {
                let emailExists = false;
                for (const parameter of this.parameters) {
                    if (parameter === 'email') {
                        emailExists = true;
                    }
                }
                if (!emailExists) {
                    this.parameters.push('email');
                    for (const parameter of this.parameters) {
                        dummyPayload[parameter] = '';
                    }
                    this.recipientSpecificParametersPayload.push(dummyPayload);
                }
            }
        });
    }

    editParameters() {
        const dialogRef = this.dialog.open(EditConfirmationComponent, {
            width: '40%',
        });

        dialogRef.afterClosed().subscribe(result1 => {
            if (result1 === 'yes') {
                this.recipientSpecificParametersPayload = [];
                const dialogRef1 = this.dialog.open(DifferentiateParametersComponent, {
                    width: '40%',
                    data: {data: this.parameters}
                });

                dialogRef1.afterClosed().subscribe(result => {
                    const dummyPayload = {};
                    if (result !== 'cancel') {
                        this.parameters = result;
                        for (const parameter of this.parameters) {
                            dummyPayload[parameter] = '';
                        }
                        this.recipientSpecificParametersPayload.push(dummyPayload);
                    }
                });
            }
        });
    }

    parameterDataCheck(templateBody) {
        const temp2 = templateBody.split(' ');
        for (let i = 0; i < temp2.length; i++) {
            const init = temp2[i].indexOf('{');
            const fin = temp2[i].indexOf('}');
            if ((!(this.parameters.some(e => e.key === temp2[i].substr(init + 2, fin - init - 2))) && temp2[i].substr(init + 2, fin - init - 2) !== '') && init !== -2 && fin !== -2) {
                this.parameters.push({'key': temp2[i].substr(init + 2, fin - init - 2), 'value': '', 'checked': false});
            }
        }
        if (this.parameters.length !== 0) {
            const dialogRef = this.dialog.open(DifferentiateParametersComponent, {
                width: '40%',
                data: {data: this.parameters}
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== 'cancel') {
                    for (const parameter of result) {
                        if (parameter.checked) {
                            this.templateParameters.push(parameter);
                        } else {
                            this.recipientSpecificParameters.push(parameter);
                        }
                    }
                }
            });

        } else {
            this.showParameters = false;
        }

    }

    parameterDataCheckFromTester(event: any) {
        // /: calculation
        this.devExURL = event.target.value;
        this.pathParameterSegregator = this.devExURL.split('/:');
        for (let i = 1; i < this.pathParameterSegregator.length; i++) {
            this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
            this.pathParameterSegregator[i] = this.pathParameterStopper[0];
        }
        // {} for calculation
        let temp2 = this.devExURL.split('/');
        // /: append
        this.pathParameter = [];
        for (let i = 1; i < this.pathParameterSegregator.length; i++) {
            this.pathParameterValue = this.pathParameterSegregator[i];
            this.find = true;
            for (let j = 0; j < this.pathParameter.length; j++) {
                if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                    this.find = false;
                }
            }
            if (this.find === true) {
                this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
            }
        }
        // {} append
        for (let i = 2; i < temp2.length; i++) {
            const init = temp2[i].indexOf('{');
            const fin = temp2[i].indexOf('}');
            if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                this.pathParameter.push({
                    'key': temp2[i].substr(init + 1, fin - init - 1),
                    'value': '',
                    'description': ''
                });
            }
        }
        // confirm to show the path parameter area.
        if (this.pathParameter.length !== 0) {
            this.showPathParamters = true;
        } else {
            this.showPathParamters = false;
        }
    }

    toggleExecutorWithID(ev, id) {
        $(id).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    addParameter() {
        const pushData = {
            'key': '',
            'value': '',
            'description': ''
        };
        this.parameterData.push(pushData);
    }

    removeParameter(index) {
        // delete this.parameterData[index];
        this.parameterData.splice(index, 1);
    }

    addHeader() {
        const pushData = {
            'key': '',
            'value': '',
            'description': ''
        };
        this.headersData.push(pushData);
    }

    removeHeader(index) {
        // delete this.headersData[index];
        this.headersData.splice(index, 1);
    }

    addFormData() {
        const pushData = {
            'key': '',
            'value': '',
            'description': ''
        };
        this.formData.push(pushData);
    }

    removeFormData(index) {
        // delete this.formData[index];
        this.formData.splice(index, 1);
    }

    attachContentType(type) {
        let contentTypeExists: boolean;
        for (const header of this.headersData) {
            if (header) {
                if (header['key'] === 'Content-Type') {
                    header['value'] = type;
                    contentTypeExists = true;
                }
            }
        }
        if (contentTypeExists !== true) {
            this.headersData.push({'key': 'Content-Type', 'value': type, 'description': ''});
        }
    }

    updateHeader() {
        this.requestBody = {};
        this.formData = [];
        this.rawRequestBody = {};
        switch (this.requestBodySelected) {
            case 'none':
                for (const i in this.headersData) {
                    if (this.headersData[i]['key'] === 'Content-Type') {
                        delete this.headersData[i];
                    }
                }
                break;
            case 'form-data':
                this.attachContentType('multipart/form-data');
                break;
            case 'x-www-form-urlencoded':
                this.attachContentType('application/x-www-form-urlencoded');
                break;
            case 'raw':
                this.attachContentType('application/json');
                break;
        }

    }

    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                // return JSON.stringify(this.editor.get());
                return this.editor.get();
            case 'binary':
            case 'none':
            default:
        }
    }

    getRequestBody() {

        if (this.requestBodySelected === 'raw') {
            const requestbody = {
                'value': this.getRequestBodyValue(this.requestBodySelected),
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'form-data') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
            const requestbody = {
                'value': this.formData,
                'key': 'payload',
                'description': 'Document in JSON format',
                'annotation': 'RequestBody'
            };
            return requestbody;
        } else if (this.requestBodySelected === 'none') {
            const requestbody = null;
            return requestbody;
        }

    }

    executeApiAndLoadResponse() {
        this.responseData = '';
        this.errorMessage = '';
        this.responseError = '';

        const payload = {
            'executor_name': this.executor_name,
            'executor_type': this.executor_type !== null ? this.executor_type : 'API',
            'executor_version': this.executor_version,
            'executor_method_type': this.httpOperation,
            'apiUrl': this.httpUrl,
            'queryParams': this.parameterData,
            'pathParams': this.pathParameter,
            'headers': this.headersData,
            'authModel': this.authModel,
            'requestBody': this.getRequestBody(),
            'executors': this.executors,
        };
        if (!(payload.authModel.hasOwnProperty('authType') && payload.authModel['authType'] !== 'no_auth')) {
            payload.authModel = null;
        }
        this.confPost.getResponseAttribute(localStorage.getItem('partner'), localStorage.getItem('account'), payload).subscribe(response => {
            this.apiByDefinition = response;
        });
    }

    collapsePanel() {
        $('#collapsablePanel').css('display', 'none');
        $('#devexGeneric').removeClass('col-md-9 col-lg-9 col-sm-12 col-xs-12').addClass('col-md-12 col-lg-12 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-9 col-md-9').addClass('col-lg-7 col-md-7');
        this.showAPIBrowser = true;

    }

    selectAPI() {
        // const dialogRef = this.dialog.open(SelectAPIComponent, {
        //     disableClose: true,
        //     width: '40%',
        //     data: { data: this.entities }
        // });
        //
        // dialogRef.afterClosed().subscribe(result => {
        //     if (result !== 'cancel') {
        //         let items1: any;
        //         let operations: any;
        //         this.confPost.getEntity(localStorage.getItem('partner'), localStorage.getItem('partner'), result['entity'], result['version']).subscribe(
        //             items => {
        //                 items1 = items;
        //                 this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(localStorage.getItem('partner'), localStorage.getItem('partner'), result['entity'], result['version']).subscribe(
        //                     executors => {
        //                         operations = executors;
        //                     });
        //             },
        //             error => { this.errorMessage = (error.error.message ? error.error.message : error.error); }
        //         );
        //     }
        // });

        $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
        $('#devexGeneric').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
        this.showAPIBrowser = false;

    }

    attachTemplateToBody() {

    }

    fetchExecutor(item) {

        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
            this.executor = exec;
            this.httpUrl = this.executor.apiUrl;
            this.executor_name = this.executor.executor_name;
            this.executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.executor_method_type = this.executor.executor_method_type;
            this.httpOperation = this.executor.executor_method_type;
            this.parameterData = this.executor.queryParams;
            this.pathParameter = this.executor.pathParams;
            this.authModel = this.executor.authModel;
            this.headersData = this.executor.headers;
            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            this.rawRequestBody = this.executor.requestBody.value;
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = this.executor.requestBody;
            this.executors = this.executor.executors;
            if (this.executor.responseAttributes !== null) {
                this.apiByDefinition = this.executor.responseAttributes;
            }
        });
    }

    executeTemplate() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'emailtemplate_execute_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        switch (this.recipientMode) {
            case 'API' :
                const payload = {
                    'executor_name': this.executor_name,
                    'executor_type': this.executor_type !== null ? this.executor_type : 'API',
                    'executor_version': this.executor_version,
                    'executor_method_type': this.httpOperation,
                    'apiUrl': this.httpUrl,
                    'dataroot': null,
                    'queryParams': this.parameterData,
                    'pathParams': this.pathParameter,
                    'headers': this.headersData,
                    'authModel': this.authModel,
                    'requestBody': this.headerChild.getRequestBody(),
                    'executors': this.executors,
                    'prerequisites': null
                };
                // if (this.authModel1) {
                //     payload['authModel'] = this.authModel1.authModel;
                // } else {
                //     payload['authModel'] = this.authModel;
                // }
                payload['authModel'] = this.headerChild.authModel1.getAuthModel();
                this.payloadToSend.to['value'] = payload;
                break;

            case 'subscribers':
                const toPayload = [];
                if (this.selectAll) {
                    for (let i = 0; i < this.subscribersData.length; i++) {
                        const tempPayload = {};
                        for (let j = 0; j < this.subscribersColumnsLength; j++) {
                            tempPayload[this.subscriberColumns[j]] = this.subscribersData[i][this.subscriberColumns[j]];
                        }
                        toPayload.push(tempPayload);
                    }
                } else {
                    for (let i = 0; i < this.subscribersChecked.length; i++) {
                        const tempPayload = {};
                        for (let j = 0; j < this.subscribersColumnsLength; j++) {
                            tempPayload[this.subscriberColumns[j]] = this.subscribersChecked[i][this.subscriberColumns[j]];
                        }
                        toPayload.push(tempPayload);
                    }
                }

                this.payloadToSend.to['value'] = toPayload;
                break;

            default :
                this.payloadToSend.to['value'] = this.recipientSpecificParametersPayload;
                break;
        }
        ;
        if (this.payloadToSend.body.type === 'emailDesigner') {
            let body = localStorage.getItem('htmlContent');
            body = JSON.parse(body);
            localStorage.removeItem('htmlContent');
            let html = body['html'];
            const editorCss = body['editorCss'];
            const narrowJumbotron = body['narrow-jumbotron'];

            // editor css
            const payload = {
                'fileName': localStorage.getItem('partner') + '-' + localStorage.getItem('account') + '-editor.css',
                'fileContent': editorCss,
                'bucketLocation': 'emailTemplate/css'
            };

            this._service.uploadTextToS3AndGetFileURL(localStorage.getItem('partner'), localStorage.getItem('account'), payload).subscribe(response => {
                html = html.replace('../../css/editor.css', response['s3URL']);
                // narrow-jumbotron css
                const payload1 = {
                    'fileName': localStorage.getItem('partner') + '-' + localStorage.getItem('account') + '-narrow-jumbotron.css',
                    'fileContent': narrowJumbotron,
                    'bucketLocation': 'emailTemplate/css'
                };

                this._service.uploadTextToS3AndGetFileURL(localStorage.getItem('partner'), localStorage.getItem('account'), payload1).subscribe(response1 => {

                    html = html.replace('narrow-jumbotron.css', response1['s3URL']);
                    this.payloadToSend.body.value = html;
                    this._service.executeEmail(this.payloadToSend, 'v1', 'campaign', 'campaign', 'emailExecutor').subscribe(data => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'emailtemplate_execute_success', 'INFO', data.status, data.statusText, '', this.payloadToSend, data, this.router.url)).then(resp => {
                            const payloadToSend = {
                                actions: resp
                            };
                            this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.platform.openSnackBar('Email(s) sent successfully', 'Success', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }, error => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'emailtemplate_execute_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.payloadToSend, error, this.router.url)).then(resp => {
                            const payloadToSend = {
                                actions: resp
                            };
                            this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                    });
                }, error => {
                    this.platform.openSnackBar('Server Error. Please try again later', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }, error => {
                this.platform.openSnackBar('Server Error. Please try again later', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });

        } else {
            this._service.executeEmail(this.payloadToSend, 'v1', 'campaign', 'campaign', 'emailExecutor').subscribe(data => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'emailtemplate_execute_success', 'INFO', data.status, data.statusText, '', this.payloadToSend, data, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.openSnackBar('Email(s) sent successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'emailtemplate_execute_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.payloadToSend, error, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
            });
        }

    }

    scheduleEmail() {
        const dialogRef = this.dialog.open(ScheduleEmailComponent, {
            width: 'auto',
            height: 'auto',
            data: {}
        });
    }
}

@Component({
    selector: 'app-differentiateparameters',
    templateUrl: 'differentiateparameters.component.html',
    styleUrls: ['differentiateparameters.component.css'],
})

export class DifferentiateParametersComponent implements OnInit {

    parameters: any;
    selectable = true;
    removable = true;
    addOnBlur = true;

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];


    constructor(public dialogRef: MatDialogRef<DifferentiateParametersComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    add(event, data): void {
        if (event.value !== 'email') {
            const input = event.input;
            const value = event.value;

            if ((value || '').trim()) {
                data.push(value.trim());
            }

            // Reset the input value
            if (input) {
                input.value = '';
            }
        }
    }

    remove(val, data): void {
        if (val !== 'email') {
            const index = data.indexOf(val);

            if (index >= 0) {
                data.splice(index, 1);
            }
        }
    }

    ngOnInit() {
        this.parameters = this.data['data'];
    }

}

@Component({
    selector: 'app-editConfirmation',
    templateUrl: 'editconfirmation.component.html',
    styleUrls: ['editconfirmation.component.css'],
})

export class EditConfirmationComponent implements OnInit {


    constructor(public dialogRef: MatDialogRef<EditConfirmationComponent>) {
    }

    ngOnInit() {
    }

}

@Component({
    selector: 'app-selectapi',
    templateUrl: 'selectapi.component.html',
    styleUrls: ['selectapi.component.css'],
})

export class SelectAPIComponent implements OnInit {

    entities = [];
    selectedEntityObject = {};

    constructor(public dialogRef: MatDialogRef<SelectAPIComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.entities = Array.of(this.data);
    }

}

@Component({
    selector: 'app-scheduleemail',
    templateUrl: 'scheduleemail.component.html',
    styleUrls: ['scheduleemail.component.css'],
})

export class ScheduleEmailComponent implements OnInit {


    constructor(public dialogRef: MatDialogRef<ScheduleEmailComponent>) {
    }

    close() {
        this.dialogRef.close();
    }

    ngOnInit() {
    }

}
